import Vue from 'vue'
import main from './main.vue'

const MainConstructor = Vue.extend(main)

let instance

const initInstance = () => {
  instance = new MainConstructor({
    el: document.createElement('div'),
  })
  document.body.appendChild(instance.$el)
}

const UploadQrcode = function (options = {}) {
  if (!instance) {
    initInstance()
  }
  for (const key in options) {
    if (instance.hasOwnProperty(key)) {
      instance[key] = options[key]
    }
  }
  instance.visible = true
}

UploadQrcode.destroy = () => {
  if (instance) {
    instance.$el.remove()
    instance.$destroy()
    instance = null
  }
}

export default UploadQrcode
export { UploadQrcode }



// WEBPACK FOOTER //
// ./src/views/question-review/components/UploadQrcode/src/main.js